var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminChange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1746_6832)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.802734,
    width: 22,
    height: 22,
    rx: 11,
    fill: "url(#paint0_linear_1746_6832)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8027 14.9982H16.3027M14.0527 6.74816C14.2516 6.54925 14.5214 6.4375 14.8027 6.4375C14.942 6.4375 15.0799 6.46493 15.2086 6.51824C15.3373 6.57154 15.4542 6.64967 15.5527 6.74816C15.6512 6.84665 15.7294 6.96358 15.7827 7.09226C15.836 7.22095 15.8634 7.35887 15.8634 7.49816C15.8634 7.63745 15.836 7.77537 15.7827 7.90406C15.7294 8.03274 15.6512 8.14967 15.5527 8.24816L9.30273 14.4982L7.30273 14.9982L7.80273 12.9982L14.0527 6.74816Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1746_6832",
    x: -23.1973,
    y: -24,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1746_6832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1746_6832",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1746_6832",
    x1: 11.8027,
    y1: 0.189363,
    x2: 22.5941,
    y2: 12.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7D00"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF950A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminChange);
export default __webpack_public_path__ + "static/media/admin-change.7b7883aeb5ce00bb670b870df5e1f826.svg";
export { ForwardRef as ReactComponent };